<template>
  <div>
<!--    IMAGE/LIGHTBOX-->
    <div class="image-display" :class="!modal ? 'hover' : ''">
      <vue-slick-carousel
          ref="carousel"
          :asNavFor="navigation"
          v-bind="imageDisplaySettings">
        <slot name="images"></slot>
        <template #prevArrow="arrowOption">
          <div class="custom-arrow">
            <a class="carousel-control-prev" role="button">
          <span class="far fa-chevron-left transparent-icon"
                aria-hidden="true"
                style="font-size: 4rem;">
          </span>
              <span class="sr-only">Previous</span>
            </a>
          </div>
        </template>
        <template #nextArrow="arrowOption">
          <div class="custom-arrow">
            <a class="carousel-control-prev" role="button">
          <span class="far fa-chevron-right transparent-icon"
                aria-hidden="true"
                style="font-size: 4rem;">
          </span>
              <span class="sr-only">Previous</span>
            </a>
          </div>
        </template>
      </vue-slick-carousel>
    </div>

<!--    NAVIGATION-->
    <div class="image-navigation" :class="modal ? 'hide' : ''">
      <vue-slick-carousel
          ref="navigation"
          :asNavFor="carousel"
          v-bind="navigationSettings"
          :slidesToShow="modal ? slidesToShow : 7"
          focusOnSelect
          @afterChange="getCurrentSlideIndex"
      >
        <slot name="thumbnails"></slot>
      </vue-slick-carousel>
    </div>
</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'CarouselLightbox',
  components: {
    VueSlickCarousel
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    slidesToShow: {
      type: Number,
    }
  },
  data() {
    return {
      navigation: undefined,
      carousel: undefined,
      navigationSettings: {
        slidesToShow: this.modal ? this.slidesToShow : 7,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
            }
          }
        ]
      },
      imageDisplaySettings: {
        slidesToShow: 1,
        fade: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: !this.modal,
              vertical: this.modal,
              slidesToShow: this.modal ? this.slidesToShow : 1,
            }
          }

        ]
      }
    }
  },
  mounted() {
    this.navigation = this.$refs.navigation
    this.carousel = this.$refs.carousel
    this.$root.$on('slideIndexChanged', data => {
        this.navigation.goTo(data)
    })
  },
  methods: {
    getCurrentSlideIndex(slideIndex) {
      this.$root.$emit('slideIndexChanged', slideIndex);
    }
  }
}
</script>

<style>
.slick-slide {
  background-color: #FFFFFF;
}

.slick-slide:hover img {
  transition: opacity 0.1s;
  -webkit-transition: opacity 0.1s;
  opacity: 1;
  cursor: pointer
}

.image-navigation img {
  transition: opacity 0.1s;
  -webkit-transition: opacity 0.1s;
  opacity: 0.5;
}

.hover.image-display:hover img {
  cursor: pointer
}


.slick-current img {
  transition: opacity 0.1s;
  -webkit-transition: opacity 0.1s;
  opacity: 1.0;
}

.slick-prev {
  left: 25px;
  z-index: 1
}
.slick-prev:before {
  content:''
}

.slick-next {
  right: 10px;
  z-index: 1
}
.slick-next:before {
  content:''
}

.slick-list {
  max-height: 30em
}

.modal-content .slick-list {
  max-height: 100%
}

@media screen and (max-width: 768px){
  .image-navigation.hide {
    display: none;
  }

  .modal-content .slick-list .slick-track {
    height: 100% !important;
  }

  .modal-content img {
    opacity: 1;
  }
}

</style>
